import axios from "axios";
import { User } from "firebase/auth";
import { getValidToken } from "./authUtils";

export interface LocalUser extends User {
  accessToken: string;
}

interface UploadFileParams {
  file: File;
  id?: string;
  documentType: string;
  documentTypeId: string;
  documentContext: string;
  description: string;
  companyId?: string;
  isUpdate?: boolean;
  documentId?: string;
}

export const uploadFile = async ({
  file,
  id,
  documentType,
  documentTypeId,
  documentContext,
  description,
  companyId,
  isUpdate = false,
  documentId,
}: UploadFileParams) => {
  const token = await getValidToken();
  const formData = new FormData();
  const localUser = sessionStorage.getItem("user");
  const userCompanyId = localUser ? JSON.parse(localUser).companyId : null;

  // Append file and metadata
  formData.append("file", file);
  if (id) {
    formData.append("id", id);
  }
  formData.append("documentType", documentType);
  formData.append("documentTypeId", documentTypeId);
  formData.append("documentContext", documentContext);
  formData.append("description", description);
  formData.append("companyId", companyId || userCompanyId);
  if (isUpdate && documentId) {
    formData.append("isUpdate", "true");
    formData.append("documentId", documentId);
  }
  const response = await axios.post(
    `${process.env.REACT_APP_API_HOST}documents/upload`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );

  if (!response.data?.isSuccess) {
    throw new Error("Failed to upload file");
  }

  return response.data.document;
};
